<app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>

<div
	class="row"
	*ngIf="loading">
	<div class="col text-center">
		<app-loader [material]="false"></app-loader>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && objective">
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			[options]="false">

			<nav
				ngbNav
				[navsetlink]="nav"
				#nav="ngbNav"
				class="nav-tabs">
				<ng-container ngbNavItem="dati">
					<a
						routerLink="."
						fragment="dati"
						ngbNavLink>
						Dati
					</a>
					<ng-template ngbNavContent>
						<form
							#editForm="ngForm"
							(ngSubmit)="editForm.valid && submit()">

							<div
								class="modal-body non-modal"
								ngbAutofocus>

								<div
									class="row"
									*ngIf="!loading && objective">
									<div class="col-sm-12">
										<!-- project -->
										<div class="row project">

											<div class="col-md-12">
												<h6>
													{{'labels.project-data' | translate |uppercase}}
												</h6>
											</div>
											<div class="form-group col-md-4">
												<label>
													{{ 'labels.name' | translate }}:
													<a
														class="link"
														routerLink="/company/project/view/{{project?.id}}">
														<span style="font-weight: bold;">{{project?.name}}</span>
													</a>

												</label>
											</div>
											<div class="form-group col-md-4">
												<label>
													{{ 'labels.startdate' | translate }}:
													<span style="font-weight: bold;">
														{{project?.startdate | date:'dd/MM/yyyy'}}
													</span>
												</label>
											</div>
											<div class="form-group col-md-4">
												<label>
													{{ 'labels.stopdate' | translate }}:
													<span style="font-weight: bold;">
														{{project?.stopdate | date:'dd/MM/yyyy'}}
													</span>
												</label>
											</div>

										</div>
										<br>
										<br>
										<div class="row">

											<!-- name -->
											<div class="form-group col-md-4">
												<label for="cname">{{ 'labels.name' | translate }}*</label>
												<input
													[disabled]="!project?.isDraft || usercompanyid"
													[(ngModel)]="objective.name"
													#name="ngModel"
													name="name"
													required
													type="text"
													class="form-control"
													placeholder="{{ 'labels.name' | translate }}"
													[ngClass]="{'is-invalid': editForm.submitted && name.invalid}">
												<div
													class="invalid-feedback"
													*ngIf="editForm.submitted && name.invalid">
													{{'errors.required' | translate}}
												</div>
											</div>

											<!-- startdate -->
											<div class="form-group col-md-4">
												<label>{{'labels.startdate' | translate}}*</label>
												<app-datepicker
													[disabled]="!project?.isDraft || usercompanyid"
													[(ngModel)]="objective.startdate"
													name="startdate"
													[min]="project?.startdateasdate"
													[max]="project?.stopdateasdate"
													required
													#startdate="ngModel"
													[ngClass]="{'is-invalid': editForm.submitted && startdate.invalid}">
												</app-datepicker>
												<div
													class="invalid-feedback"
													*ngIf="editForm.submitted && startdate.invalid"
													style="display: block;">
													{{'errors.required' | translate}}
												</div>
											</div>
											<!-- stopdate -->
											<div class="form-group col-md-4">
												<label>{{'labels.stopdate' | translate}}*</label>
												<app-datepicker
													[(ngModel)]="objective.stopdate"
													name="stopdate"
													required
													[disabled]="!objective.startdate || !project?.isDraft || usercompanyid"
													#stopdate="ngModel"
													[min]="project?.startdateasdate"
													[max]="project?.stopdateasdate"
													[ngClass]="{'is-invalid': editForm.submitted && stopdate.invalid}">
												</app-datepicker>
												<div
													class="invalid-feedback"
													*ngIf="editForm.submitted && stopdate.invalid"
													style="display: block;">
													{{'errors.required' | translate}}
												</div>
											</div>
											<!-- description -->
											<div class="form-group col-md-12">
												<label>{{ 'labels.description' | translate }}*</label>
												<quill-editor
													[disabled]="!project?.isDraft || usercompanyid"
													name="description"
													[required]="true"
													[(ngModel)]="objective.description"
													placeholder
													#description="ngModel"
													[ngClass]="editForm.submitted && description.invalid ? 'is-invalid' : ''">
												</quill-editor>
												<div
													class="invalid-feedback"
													*ngIf="editForm.submitted && description.invalid">
													{{'errors.required' | translate}}
												</div>
											</div>
										</div>
									</div>

								</div>
							</div>
							<div
								class="modal-footer non-modal-footer"
								*ngIf="objective && project">

								<button
									routerLink="{{'/company/project/view/' + project.id}}"
									fragment="obiettivi"
									type="button"
									class="btn btn-primary">
									{{'labels.cancel' | translate}}
								</button>
								<button
									type="submit"
									class="btn btn-primary">
									{{'labels.save' | translate}}
								</button>
							</div>
						</form>
					</ng-template>
				</ng-container>
				<ng-container
					ngbNavItem="sezioniaggiuntive"
					[disabled]="!objective.id">

					<a
						routerLink="."
						fragment="sezioniaggiuntive"
						ngbNavLink>
						Sezioni aggiuntive
					</a>
					<ng-template ngbNavContent>
						<app-additional-sections
							*ngIf="project"
							[eid]="objective.id"
							[tenderid]="project.tenderid"
							entity="objective"></app-additional-sections>
					</ng-template>
				</ng-container>
			</nav>

			<div
				[ngbNavOutlet]="nav"
				class="mt-2"></div>
		</app-card>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && error">
	<div class="col-sm-12">
		<app-card [hidHeader]="true">
			{{'errors.loading.objective' | translate}}
		</app-card>

	</div>
</div>
